<template>
  <section id="contact" class="section contact">
    <div class="section-inner">
      <div v-reveal class="contact-card">
        <span class="eyebrow">06 — contato</span>

        <h2 class="contact-title">
          Vamos construir algo <span class="hl">inteligente</span>?
        </h2>

        <p class="section-lead contact-lead">
          Estou aberto a conversas sobre produtos com IA, arquitetura de agentes
          e projetos que precisam sair do papel.
        </p>

        <a class="mail mono" href="mailto:juliocesar.dev.system@gmail.com">
          juliocesar.dev.system@gmail.com
        </a>

        <div class="links">
          <a
            v-for="link in links"
            :key="link.label"
            class="link"
            :href="link.href"
            target="_blank"
            rel="noopener"
          >
            <v-icon size="18">{{ link.icon }}</v-icon>
            {{ link.label }}
          </a>
        </div>
      </div>

      <footer class="footer">
        <span class="mono">© {{ year }} Júlio César</span>
        <span class="mono footer-built">
          feito com Vue + Vuetify · Caruaru - PE
        </span>
      </footer>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactPage",

  data() {
    return {
      links: [
        {
          label: "GitHub",
          icon: "mdi-github",
          href: "https://github.com/jces4rrr",
        },
        {
          label: "LinkedIn",
          icon: "mdi-linkedin",
          href: "https://www.linkedin.com/in/j%C3%BAlio-c%C3%A9sar-b544a1215/",
        },
      ],
    };
  },

  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
